import axios from "axios";
import { getApiLanguageId } from "../utils/apiLanguageId.js";

export default class ApiClient {

    constructor() {}

    request({ method, path, data, languageId: languageIdOverride } = {}) {
        if (!method) {
            method = 'GET';
        }

        if (!path) {
            console.error('Path is required');
        }

        if (data && typeof data !== 'object' && !Array.isArray(data)) {
            console.error('Data must be an array or object');
        }

        const languageId =
            languageIdOverride !== undefined && languageIdOverride !== null && languageIdOverride !== ''
                ? languageIdOverride
                : getApiLanguageId();
        return axios.post('/api', { method, path, data, languageId })
    }
}
